import { z } from 'zod';
import { centsSchema, idSchema, isoDateSchema, positiveCentsSchema, interestRateSchema, timestampSchema, } from './common.js';
/** 40 ans : au-delà, la saisie est une erreur. */
const MAX_DURATION_MONTHS = 480;
export const loanInputSchema = z.object({
    lender: z.string().trim().min(1).max(120),
    principalCents: positiveCentsSchema,
    /** Taux nominal annuel, hors assurance. */
    annualRate: interestRateSchema,
    /** Assurance emprunteur : taux annuel sur le capital initial. */
    insuranceAnnualRate: interestRateSchema.default(0),
    durationMonths: z.number().int().min(1).max(MAX_DURATION_MONTHS),
    /** Date de déblocage ; la première échéance tombe un mois plus tard. */
    startDate: isoDateSchema,
});
/** Les conditions financières, qui se figent dès que l'échéancier existe. */
export const LOAN_TERM_FIELDS = [
    'principalCents',
    'annualRate',
    'insuranceAnnualRate',
    'durationMonths',
    'startDate',
];
export const loanUpdateSchema = z
    .object({
    lender: loanInputSchema.shape.lender,
    principalCents: loanInputSchema.shape.principalCents,
    annualRate: loanInputSchema.shape.annualRate,
    insuranceAnnualRate: interestRateSchema,
    durationMonths: loanInputSchema.shape.durationMonths,
    startDate: loanInputSchema.shape.startDate,
    archived: z.boolean(),
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, { message: 'Aucun champ à modifier' });
export const loanSchema = z.object({
    id: idSchema,
    propertyId: idSchema,
    lender: z.string(),
    principalCents: centsSchema,
    annualRate: z.number(),
    insuranceAnnualRate: z.number(),
    durationMonths: z.number().int(),
    startDate: isoDateSchema,
    /** Vrai dès que l'échéancier est généré : les conditions ne sont alors plus modifiables. */
    hasSchedule: z.boolean(),
    archivedAt: timestampSchema.nullable(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
});
export const scheduleRowSchema = z.object({
    installment: z.number().int().positive(),
    dueDate: isoDateSchema,
    principalCents: centsSchema,
    interestCents: centsSchema,
    insuranceCents: centsSchema,
    paymentCents: centsSchema,
    balanceCents: centsSchema,
});
export const scheduleTotalsSchema = z.object({
    principalCents: centsSchema,
    interestCents: centsSchema,
    insuranceCents: centsSchema,
    paymentCents: centsSchema,
});
export const scheduleSchema = z.object({
    loanId: idSchema,
    generated: z.boolean(),
    /** Première échéance hors assurance ; `null` tant que l'échéancier n'est pas généré. */
    monthlyPaymentCents: centsSchema.nullable(),
    totals: scheduleTotalsSchema.nullable(),
    rows: z.array(scheduleRowSchema),
});
//# sourceMappingURL=loan.js.map